export default "__VITE_ASSET__DeqGSKCT__"